import { tns } from "tiny-slider/src/tiny-slider"

'use strict'

const media = {
		init: function () {
				let el = document.querySelectorAll(".top-slider");
						for (let i = 0; i < el.length; i++) {
							var slider = tns({
								container: el[i],
								items: 1,
								loop: false,
								slideBy: 'page'
							});
							var wrapper = el[i].closest(".top-slider--wrapper")

							var tnsPrevButton = wrapper.querySelector('[data-controls="prev"]')
							var tnsNextButton = wrapper.querySelector('[data-controls="next"]')

							var prevButtons = wrapper.querySelectorAll('[data-slider-prev]')
							var nextButtons = wrapper.querySelectorAll('[data-slider-next]')

							for (let i = 0; i < prevButtons.length; i++) {
								let prevButton = prevButtons[i]

								prevButton.addEventListener('click', (e) => {
										tnsPrevButton.click()
								})
							}

							for (let i = 0; i < nextButtons.length; i++) {
								let nextButton = nextButtons[i]

								nextButton.addEventListener('click', (e) => {
										tnsNextButton.click()
								})
						}
				}
    },
}

export default media.init()
